import React, { Fragment } from "react";

export default (
  <>
    <path d="M19.71 12a.86.86 0 00-.85.86v8.57c0 .47-.39.86-.86.86H2.57a.86.86 0 01-.86-.86V4.29c0-.48.39-.86.86-.86h10.29a.86.86 0 100-1.72H2.57A2.57 2.57 0 000 4.3v17.14A2.57 2.57 0 002.57 24H18a2.57 2.57 0 002.57-2.57v-8.57a.86.86 0 00-.86-.86z" />
    <path d="M23.04.96a3.28 3.28 0 00-4.64 0L7.1 12.26c-.09.09-.16.2-.2.33L5.2 17.73a.86.86 0 001.08 1.08l5.14-1.71a.86.86 0 00.34-.2L23.04 5.6a3.28 3.28 0 000-4.64zM21.83 4.4L10.68 15.53l-3.32 1.11 1.1-3.32L19.61 2.18a1.57 1.57 0 012.22 2.21z" />
  </>
);
